import { render, staticRenderFns } from "./OmsDialog.vue?vue&type=template&id=5e99b6e2&scoped=true"
import script from "./OmsDialog.vue?vue&type=script&lang=js"
export * from "./OmsDialog.vue?vue&type=script&lang=js"
import style0 from "./OmsDialog.vue?vue&type=style&index=0&id=5e99b6e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99b6e2",
  null
  
)

export default component.exports